module.exports = __webpack_public_path__ + "img/promo.7ba705fd.svg";